import React, { useState, useEffect, Fragment, useRef } from "react";
import { BanIcon, RefreshIcon } from "@heroicons/react/outline";
import { CogIcon } from "@heroicons/react/solid";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import CustomerServices from "../../services/CustomerServices";
import { convert, validateDate } from "./../../utils/convertDate";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowNarrowLeftIcon } from "@heroicons/react/solid";

export default function ViewCustomer() {
  const statusStyles = {
    Active: "bg-green-500 text-white",
    Disabled: "bg-amber-400 text-white",
    Inactive: "bg-orange-600 text-white",
  };
  const name = new URLSearchParams(window.location.search).get("id");
  const errors = {
    commentError: "",
    commentIsValidated: false,
    formIsSubmitting: false,
  };
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [formState, setFormState] = useState(errors);
  const [commentValue, setCommentValue] = useState({
    comment: "",
  });
  const [customer, setCustomer] = useState({});
  const [loading, setLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState();
  const [imgUrl2, setImgUrl2] = useState();
  const [bvnImg, setBvnImg] = useState();
  const [account, setAccount] = useState([]);
  const [bvnName, setBVName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [bvnDetails, setBVNDet] = useState("");
  const [kinDetails, setKinDetails] = useState("");
  const [address, setAddress] = useState("");
  const [resAddress, setResAdress] = useState("");
  const [adminType, setAdminType] = useState("");

  // comment validation
  const formHandler = {
    commentHandler: (event) => {
      setCommentValue({ ...commentValue, comment: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          commentError: "Comment cannot be empty",
          commentIsValidated: false,
        });
        return;
      }

      setFormState({
        ...formState,
        commentError: "",
        commentIsValidated: true,
      });
    },
  };
  const handleApprove = async () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const blockCustomer = async () => {
    const isFiiled = formState.commentIsValidated;
    if (!isFiiled) {
      fire("error", "Input field is required");
      return;
    }
    const block = await CustomerServices.blockCustomer({
      userName: name,
      comment: commentValue.comment,
    });
    if (block) {
      fire("success", block.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };
  const unblockCustomer = async () => {
    setLoading(true);
    if (
      adminType.toLowerCase() === "maker" &&
      customer?.activationApprovalStatus.toLowerCase() === "initiated"
    ) {
      setLoading(false);
      fire(
        "error",
        "This has already been initiated and awaiting approval of a checker"
      );
      return;
    }

    if (
      adminType.toLowerCase() === "checker" &&
      customer?.activationApprovalStatus.toLowerCase() !== "initiated"
    ) {
      fire("error", "Maker approval action is required first");
      setLoading(false);
      return;
    }
    const response = await CustomerServices.UnBlockCustomer({ userName: name });
    if (response) {
      fire("success", response.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
      setLoading(false);
    }
  };

  const reactivateCustomer = async (e) => {
    e.preventDefault();
    setLoading(true);
    const block = await CustomerServices.unLockCustomer({ userName: name });
    if (block) {
      fire("success", block.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }

    setLoading(false);
  };

  const ViewCustomer = async () => {
    const customer = await CustomerServices.viewCustomer(name);
    setCustomer(customer?.data);
    setBVName(customer?.data?.bvn);
    setCustomerName(customer?.data?.userName);
    setBVNDet(customer?.data?.bvnNavigation);
    setKinDetails(customer?.data?.nextOfKin);
    setAddress(customer?.data?.encondedLocationUrl);
    setResAdress(customer?.data?.residentialAddress);

    var details = sessionStorage.getItem("user");
    var userDetails = JSON.parse(details);
    var type = userDetails.adminType;
    setAdminType(type);

    if (customer) {
      setAccount([...customer?.data?.customerAccounts]);

      // Always try to load selfieUrl (even if null)
      try {
        if (customer?.data?.selfieUrl) {
          const response = await fetch(customer?.data?.selfieUrl);
          if (response.ok) {
            const imageBlob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(imageBlob);
            reader.onloadend = () => {
              const base64data = reader.result;
              setImgUrl(base64data);
            };
          }
        }
      } catch (error) {
        console.error("Error loading selfie image:", error);
        setImgUrl(null); // Explicitly set to null if loading fails
      }

      // Only load deviceChangeSelfieUrl if it exists
      if (customer?.data?.deviceChangeSelfieUrl) {
        try {
          const response = await fetch(customer?.data?.deviceChangeSelfieUrl);
          if (response.ok) {
            const imageBlob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(imageBlob);
            reader.onloadend = () => {
              const base64data = reader.result;
              setImgUrl2(base64data);
            };
          }
        } catch (error) {
          console.error("Error loading device change image:", error);
        }
      }

      // Handle BVN image
      if (customer?.data?.bvnNavigation?.base64Image) {
        try {
          const nresponse = await fetch(
            customer?.data?.bvnNavigation?.base64Image
          );
          const nimageBlob = await nresponse.blob();
          const nreader = new FileReader();
          nreader.readAsDataURL(nimageBlob);
          nreader.onloadend = () => {
            const base64data = nreader.result;
            setBvnImg(base64data);
          };
        } catch (error) {
          console.error("Error loading BVN image:", error);
        }
      }
    }
  };

  const syncBVN = async () => {
    setLoading(true);
    const resp = await CustomerServices.syncBVN({
      bvn: bvnName,
      userName: customerName,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }

    setLoading(false);
  };

  const blockAccount = async () => {
    setLoading(true);
    const resp = await CustomerServices.blockAccount(name);
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }

    setLoading(false);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  useEffect(() => {
    ViewCustomer();
  }, []);
  return (
    <>
      <Layout title={""} pageTag={"customer"} current={"/customers"}>
        <main>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="py-4">
              <a href={`/customers`}>
                <div className="flex">
                  <ArrowNarrowLeftIcon className="w-6 h-4 flex self-center" />
                  <p> Back</p>
                </div>
              </a>
              <div
                className={`mt-1 relative rounded-md flex justify-center ${
                  customer?.deviceChangeSelfieUrl && "gap-5"
                }`}
              >
                {/* Always show selfie container, even if empty */}
                <div className="flex flex-col gap-2 font-semibold uppercase">
                  <p>Initial Capture</p>
                  {imgUrl ? (
                    <img
                      className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                      src={imgUrl}
                      alt="Initial capture"
                    />
                  ) : (
                    <div className="inline-block h-28 w-28 rounded-full border-8 border-rose-600 bg-white items-center justify-center">
                      <span className="text-xs text-gray-500">

                      </span>
                    </div>
                  )}
                </div>

                {/* Only show device change container if imgUrl2 exists */}
                {imgUrl2 && (
                  <div className="flex flex-col gap-2 font-semibold uppercase">
                    <p>Device Change</p>
                    <img
                      className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                      src={imgUrl2}
                      alt="Device change capture"
                    />
                  </div>
                )}
              </div>
              <div className="flex justify-center">
                <div className="font-bold">
                  {customer?.firstName} {customer?.surname}{" "}
                  <span
                    className={classNames(
                      statusStyles[customer?.customerStatus],
                      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                    )}
                  >
                    {customer?.customerStatus}
                  </span>{" "}
                  <br />
                  <span className="text-sm text-center ml-4 flex justify-evenly font-thin">
                    {" "}
                    Username:
                    <span className="text-green-400 font-thin">
                      {customer?.userName}
                    </span>
                  </span>{" "}
                </div>
              </div>
              <div className="mt-4 items-center sm:mt-0 sm:ml-16 sm:flex justify-end relative bottom-10">
                {customer?.customerStatus === "Active" ? (
                  <>
                    {loading === false ? (
                      <button
                        type="submit"
                        onClick={handleApprove}
                        className="mr-2  hover:text-white active:text-white inline-flex btn-error items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-error shadow-sm  sm:w-auto"
                      >
                        <BanIcon className="w-3 mr-1.5" />
                        Block Customer
                      </button>
                    ) : (
                      <HollowDotsSpinner size={20} color="#4D627E" />
                    )}
                  </>
                ) : (
                  <>
                    {loading === false ? (
                      <button
                        type="submit"
                        onClick={unblockCustomer}
                        className="mr-2  hover:text-white bg-green-400 active:text-white inline-flex btn-green items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-green-400 shadow-sm  sm:w-auto"
                      >
                        <BanIcon className="w-3 mr-1.5" />
                        Unblock Customer
                      </button>
                    ) : (
                      <HollowDotsSpinner size={20} color="#079D4F" />
                    )}
                  </>
                )}

                <Link
                  to={`/customer/settings?id=${customer?.userName}`}
                  className="flex border rounded-md px-2 py-2"
                >
                  <CogIcon className="w-4 text-gray-500 " /> Settings
                </Link>
              </div>
              {customer?.customerStatus !== "Active" ? (
                <p className="mt-8 items-center mr-10 sm:flex justify-end relative bottom-10">
                  <div className="tooltip">
                    <p className="text-rose-600">
                      Reason for blocking customer
                    </p>
                    <span className="tooltiptext ">
                      {" "}
                      <p className="m-4 text-left">
                        {customer?.reasonForDeactivation}
                      </p>
                    </span>
                  </div>
                </p>
              ) : (
                ""
              )}

              <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex"></div>
                </div>
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <form>
                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <div className="p-6">
                              <div className="flex justify-between">
                                <h4 className="font-bold">NAMES</h4>
                                {customer?.isLocked === true ? (
                                  <button
                                    type="submit"
                                    onClick={reactivateCustomer}
                                    className="mr-2  hover:text-white active:text-white bg-green-400 inline-flex btn-green items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-green-400 shadow-sm  sm:w-auto"
                                  >
                                    <BanIcon className="w-3 mr-1.5" />
                                    Reactivate Customer
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div className="sm:col-span-1">
                                  <label
                                    htmlFor="first-name"
                                    className=" block text-sm font-medium text-gray-700"
                                  >
                                    Title{" "}
                                    <span className="text-red-600">*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="title"
                                      disabled="true"
                                      defaultValue={bvnDetails?.title ?? customer?.title}
                                      id="title"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="firstName"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    First name{" "}
                                    <span className="text-red-600">*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="firstName"
                                      disabled="true"
                                      defaultValue={customer?.firstName}
                                      id="firstName"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-1">
                                  <label
                                    htmlFor="middleName"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Middle Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="middleName"
                                      disabled="true"
                                      defaultValue={customer?.middleName}
                                      id="middleName"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="lastName"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Last Name{" "}
                                    <span className="text-red-600">*</span>
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="lastName"
                                      id="lastName"
                                      disabled="true"
                                      defaultValue={customer?.surname}
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <div className="px-6 py-6">
                              <h4 className="font-bold">
                                PERSONAL INFORMATION
                              </h4>
                              <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="dob"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Date of Birth
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="dob"
                                      id="dob"
                                      disabled="true"
                                      value={convert(customer?.dateOfBirth)}
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-1">
                                  <label
                                    htmlFor="gender"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Gender
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="gender"
                                      id="gender"
                                      disabled="true"
                                      defaultValue={customer?.gender}
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-1">
                                  <label
                                    htmlFor="maritalStatus"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Marital Status
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="maritalStatus"
                                      id="maritalStatus"
                                      disabled="true"
                                      defaultValue={customer?.maritalStatus}
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="nin"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Inputted NIN
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="nin"
                                      id="nin"
                                      disabled="true"
                                      defaultValue={customer?.nin ?? ""}
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="phone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Phone Number
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="phone"
                                      id="phone"
                                      disabled="true"
                                      defaultValue={customer?.phoneNumber}
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Email
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="email"
                                      disabled="true"
                                      defaultValue={customer?.emailAddress}
                                      id="email"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Alias
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="email"
                                      disabled="true"
                                      defaultValue={customer?.customerAlias}
                                      id="email"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>

                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Occupation
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="email"
                                      disabled="true"
                                      defaultValue={customer?.occupation}
                                      id="email"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>

                                <div className="sm:col-span-2 mt-1">
                                  <label
                                    htmlFor="maiden"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Location at signup
                                  </label>
                                  <a
                                    target="blank"
                                    href={`${process.env.REACT_APP_MAP}${address}`}
                                    className="mr-2  hover:text-white active:text-white inline-flex bg-green-400 items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                  >
                                    View Location
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <div className="p-6">
                              <div className="flex justify-between">
                                <h4 className="font-bold">
                                  ACCOUNT INFORMATION
                                </h4>
                                {loading === false ? (
                                  <button
                                    type="submit"
                                    onClick={blockAccount}
                                    className="mr-2  hover:text-white active:text-white inline-flex btn-error items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-error shadow-sm  sm:w-auto"
                                  >
                                    <BanIcon className="w-3 mr-1.5" />
                                    Block Account
                                  </button>
                                ) : (
                                  <HollowDotsSpinner
                                    className="justify-center"
                                    size={20}
                                    color="#4D627E"
                                  />
                                )}
                              </div>

                              {account.map((acct, i) => (
                                <div key={i} className="mt-6 grid ">
                                  <div  className=" ">
                                    <div className="flex">
                                      <div className="mr-3 w-1/2">
                                        <label
                                          htmlFor="account"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Account Name {i + 1}
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="account"
                                            id="account"
                                            disabled="true"
                                            defaultValue={acct.accountName}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="mr-3 w-1/2">
                                        <label
                                          htmlFor="account"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Account Number {i + 1}
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="account"
                                            id="account"
                                            disabled="true"
                                            defaultValue={acct.accountNumber}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="mr-3 w-1/2">
                                        <label
                                          htmlFor="accountType"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Account Type {i + 1}
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="accountType"
                                            id="accountType"
                                            disabled="true"
                                            defaultValue={acct.accountType}
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                      <div className="w-1/2">
                                        <label
                                          htmlFor="accountType"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          PND Restriction {i + 1}
                                        </label>
                                        <div className="mt-1">
                                          <input
                                            type="text"
                                            name="accountType"
                                            id="accountType"
                                            disabled="true"
                                            defaultValue={
                                              acct.accountOnPnd === false
                                                ? "Not Blocked"
                                                : "Blocked"
                                            }
                                            className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <div className="p-6">
                              <div className="flex justify-between">
                                <h4 className="font-bold">BVN DETAILS</h4>
                                <div className=" sm:mt-0 sm:ml-16 sm:flex justify-end relative flex-none">
                                  {loading === false ? (
                                    <button
                                      type="button"
                                      onClick={syncBVN}
                                      className=" btn-primary align-center flex justify-center items-center rounded-md border border-transparent py-2 px-4  text-sm font-medium text-white shadow-sm  sm:w-auto"
                                    >
                                      <RefreshIcon className="w-3 mr-1.5" />
                                      Sync Details
                                    </button>
                                  ) : (
                                    <HollowDotsSpinner
                                      size={20}
                                      color="#4D627E"
                                    />
                                  )}
                                </div>
                              </div>
                              <div className=" justify-center flex mb-4">
                                <div className="mt-1 relative rounded-md flex justify-center">
                                  <img
                                    className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                                    src={bvnImg}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className=" grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="title"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Title
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvn"
                                      id="bvn"
                                      disabled="true"
                                      defaultValue={
                                        bvnDetails?.title
                                      }
                                      className="bg-gray-100 shadow-sm  block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnName"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    First Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnName"
                                      id="bvnName"
                                      disabled="true"
                                      defaultValue={bvnDetails?.firstName}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnName"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Last Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnName"
                                      id="bvnName"
                                      disabled="true"
                                      defaultValue={bvnDetails?.lastName}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvn"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Bank Verification Number(BVN)
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvn"
                                      id="bvn"
                                      disabled="true"
                                      defaultValue={bvnDetails?.bvn}
                                      className="bg-gray-100 shadow-sm  block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>

                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnBank"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Bank Registered
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnBank"
                                      id="bvnBank"
                                      disabled="true"
                                      defaultValue={bvnDetails?.enrollmentBank}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnYear"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Date of Registration
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnYear"
                                      id="bvnYear"
                                      disabled="true"
                                      value={validateDate(
                                        bvnDetails?.registrationDate
                                      )}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Phone Number Registered
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.phoneNumber}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Enrollment Branch
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={
                                        bvnDetails?.enrollmentBranch
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Account Level
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.levelOfAccount}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="dateOfBirth"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Date of Birth
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="dateOfBirth"
                                      id="dateOfBirth"
                                      disabled="true"
                                      value={validateDate(
                                        bvnDetails?.dateOfBirth
                                      )}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="gender"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Gender
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="gender"
                                      id="gender"
                                      disabled="true"
                                      defaultValue={bvnDetails?.gender}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Marital Status
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.maritalStatus}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State of Origin
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.stateOfOrigin}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State of Residence
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={
                                        bvnDetails?.stateOfResidence
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    WatchListed
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.watchListed}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    National Identification Number
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.nin}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Nationality
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.nationality}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    LGA of Origin
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.lgaOfOrigin}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    LGA of Residence
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.lgaOfResidence}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Name on Card
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.nameOnCard}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Email Address
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={bvnDetails?.email}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-6">
                                  <label
                                    htmlFor="bvnPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Residential Address
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="bvnPhone"
                                      id="bvnPhone"
                                      disabled="true"
                                      defaultValue={
                                        bvnDetails?.residentialAddress
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <div className="p-6">
                              <h4 className="font-bold">ADDRESS</h4>
                              <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div className="sm:col-span-3">
                                  <label
                                    htmlFor="state"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State of Residence
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="state"
                                      id="state"
                                      disabled="true"
                                      defaultValue={customer?.state}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-3">
                                  <label
                                    htmlFor="state"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    LGA of Residence
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="state"
                                      id="state"
                                      disabled="true"
                                      defaultValue={customer?.lga}
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-5">
                                  <label
                                    htmlFor="resAddress"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Residential Address
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="resAddress"
                                      id="resAddress"
                                      disabled="true"
                                      defaultValue={
                                        customer?.residentialAddress
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-1">
                                  <label
                                    htmlFor="resLocation"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    View Address
                                  </label>
                                  <a
                                    target="blank"
                                    href={`${process.env.REACT_APP_MAP}${resAddress}`}
                                    className="mr-2  hover:text-white active:text-white inline-flex bg-green-400 items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                  >
                                    View
                                  </a>
                                </div>
                                <div className="sm:col-span-4">
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Nearest Bus stop
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="email"
                                      disabled="true"
                                      defaultValue={customer?.nearestBusStop}
                                      id="email"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Landmark
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="email"
                                      disabled="true"
                                      defaultValue={customer?.majorLandmark}
                                      id="email"
                                      className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <div className="p-6">
                              <h4 className="font-bold">NEXT OF KIN</h4>
                              <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="kinSurname"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Surname
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="kinSurname"
                                      id="kinSurname"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.surname
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="kinFirstname"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    First Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="kinFirstname"
                                      id="kinFirstname"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.firstName
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="kinMid"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Middle Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="kinMid"
                                      id="kinMid"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.middleName
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>

                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="kinPhone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Phone Number
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="kinPhone"
                                      id="kinPhone"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.phoneNumber
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="kinEmail"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Email
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="kinEmail"
                                      id="kinEmail"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.emailAddress
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="relationship"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Relationship
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="relationship"
                                      id="relationship"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.relationship
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="gender"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Gender
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="gender"
                                      id="gender"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.gender
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="relationship"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State of Residence
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="state"
                                      id="state"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.stateofResidence
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-2">
                                  <label
                                    htmlFor="dob"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Date of Birth
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="dob"
                                      id="dob"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : validateDate(kinDetails.dateOfBirth)
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                                <div className="sm:col-span-6">
                                  <label
                                    htmlFor="address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Residential Address
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="address"
                                      id="address"
                                      disabled="true"
                                      defaultValue={
                                        kinDetails === null
                                          ? "N/A"
                                          : kinDetails.residentialAddress
                                      }
                                      className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/* Approve modal */}
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={handleClose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                    <div>
                      <div className="mt-3 text-center sm:mt-5">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium text-gray-900"
                        >
                          Hey, wait!!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want to block this customer?
                          </p>
                          <form>
                            <label
                              htmlFor="comment"
                              className="text-left mt-2 block text-sm font-medium text-gray-700"
                            >
                              Comment
                            </label>
                            <div className="mt-1">
                              <input
                                id="comment"
                                name="comment"
                                type="text"
                                placeholder="Enter comment"
                                autoComplete="text"
                                value={commentValue.comment}
                                onChange={formHandler.commentHandler}
                                required
                                className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              />
                              {!formState.commentIsValidated &&
                                formState.commentError && (
                                  <div className="text-red-800">
                                    {formState.commentError}
                                  </div>
                                )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      {loading === false ? (
                        <button
                          type="button"
                          className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                          onClick={(text) => blockCustomer(text)}
                        >
                          Yes, I do
                        </button>
                      ) : (
                        <HollowDotsSpinner size={15} color="#4D627E" />
                      )}

                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={() => setOpen(false)}
                        ref={cancelButtonRef}
                      >
                        No, I don't
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </Layout>
    </>
  );
}
